// show a preview of an uploaded image in a fixed size container
//
//   <fixed-image-preview src="{...}" width="1280" height="720" />
//

let module = angular.module('app.directives');

module.directive('fixedImagePreview', function () {
  'ngInject';
  return {
    scope: {
      src: '=',
      width: '=',
      height: '=',
      onLoad: '&',
    },
    template: `
      <div style="background:#eee;position:relative" ng-style="{width: width, height: height}">
        <div style="position:absolute;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;" ng-style="{
          'background-image': 'url(&quot;'+src+'&quot;)',
          'background-repeat': 'no-repeat',
          'background-position': '0% 0%',
          'background-size': 'contain',
        }">
          <small style="flex:1;color:#aaa;text-align:center;" ng-show="!src">Not Configured</small>
          <img ng-src="{{src}}" style="visibility:hidden;height:1px;width:1px;" ng-onload="onLoad({$event: $event})">
        </div>
      </div>
    `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/fixed-image-preview.js